var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1877_4911)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.70286 18H14.2971C16.3414 18 18 16.3414 18 14.2971V3.70286C18 1.65857 16.3414 0 14.2971 0H3.70286C1.65857 0 0 1.65857 0 3.70286V14.2971C0 16.3414 1.65857 18 3.70286 18ZM2.10857 3.71571C2.10857 2.82857 2.82857 2.12143 3.70286 2.12143V2.10857H14.2971C15.1843 2.10857 15.8914 2.82857 15.8914 3.70286V14.2971C15.8914 15.1843 15.1714 15.8914 14.2971 15.8914H3.70286C2.81571 15.8914 2.10857 15.1714 2.10857 14.2971V3.71571ZM5.69554 6.17163H12.3041H12.317C12.8955 6.17163 13.3713 5.69591 13.3713 5.11734C13.3713 4.53877 12.8955 4.06306 12.317 4.06306H5.69554C5.11697 4.06306 4.64125 4.53877 4.64125 5.11734C4.64125 5.69591 5.11697 6.17163 5.69554 6.17163ZM12.3041 10.0545H5.69554C5.11697 10.0545 4.64125 9.57877 4.64125 9.0002C4.64125 8.42163 5.11697 7.94591 5.69554 7.94591H12.317C12.8955 7.94591 13.3713 8.42163 13.3713 9.0002C13.3713 9.57877 12.8955 10.0545 12.317 10.0545H12.3041ZM5.69554 13.9502H8.34411C8.92268 13.9502 9.3984 13.4745 9.3984 12.8959C9.3984 12.3173 8.92268 11.8416 8.34411 11.8416H5.69554C5.11697 11.8416 4.64125 12.3173 4.64125 12.8959C4.64125 13.4745 5.11697 13.9502 5.69554 13.9502Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1877_4911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLibrary);
export default __webpack_public_path__ + "static/media/icon-library.e2b79fbef9678c0b1d0d48fab977b40d.svg";
export { ForwardRef as ReactComponent };